export type ActivityNames =
  | 'LONG_MULTI_1'
  | 'LONG_MULTI_2'
  | 'LONG_MULTI_TWO_DIGIT'
  | 'LONG_MULTI_THREE_DIGIT'
  | 'LONG_MULTI_DECIMAL'
  | 'LONG_MULTI_DECIMAL_TWO_DIGITS'
  | 'LONG_MULTI_DECIMAL_THREE_DIGITS'
  | 'LONG_MULTI_DECIMAL_THREE_DIGITS2'

export interface TaskHistory {
  multiplier: number
  multiplicand: number
}

export interface Ranges {
  multiplierMin: number
  multiplierMax: number
  multiplicandMin: number
  multiplicandMax: number
}

export enum LongMultiStateKey {
  ANSWER = 'answer',
  ADDITON_ROW_1 = 'additon-row-1',
  ADDITON_ROW_2 = 'additon-row-2',
  ADDITON_ROW_3 = 'additon-row-3',
  CARRIED_NUMBERS_MULT_ROW_1 = 'carried-numbers-mult-row-1',
  CARRIED_NUMBERS_MULT_ROW_2 = 'carried-numbers-mult-row-2',
  CARRIED_NUMBERS_MULT_ROW_3 = 'carried-numbers-mult-row-3',
  CARRIED_NUMBERS_ADDITION = 'carried-numbers-addition',
}

export type LongMultiTwoDigitStateKeys =
  | LongMultiStateKey.ANSWER
  | LongMultiStateKey.ADDITON_ROW_1
  | LongMultiStateKey.ADDITON_ROW_2
  | LongMultiStateKey.CARRIED_NUMBERS_MULT_ROW_1
  | LongMultiStateKey.CARRIED_NUMBERS_MULT_ROW_2
  | LongMultiStateKey.CARRIED_NUMBERS_ADDITION

export type LongMultiTwoDigitState = {
  [key in Extract<LongMultiStateKey, LongMultiTwoDigitStateKeys>]: Record<string, string>
}

export type LongMultiThreeDigitState = {
  [key in LongMultiStateKey]: Record<string, string>
}

export interface LongMultiDecimalGeneratedValues {
  multiplicand: number
  multiplier: number
}

export enum LatticeRowType {
  NUM = 'num',
  CARR = 'carried',
  SUM = 'sum',
  CELL = 'cell',
  FILLER = '',
}

export type LatticeRow =
  | {
      type: LatticeRowType.NUM
      value: string
      itemIndex?: number
      decimalPosition?: 'bottom' | 'right' | undefined
      hasCarriedNumber?: boolean
      carriedName?: string
    }
  | { type: LatticeRowType.FILLER }
  | { type: LatticeRowType.CARR; name: string }
  | { type: LatticeRowType.CELL; names: string[]; name?: string | number }
  | { type: LatticeRowType.SUM; name: string; decimalPosition?: 'bottom' | 'right' | undefined; itemIndex?: number }

export type CellKey = `${number}-${number}`
export type CellName = `${number}:${CellKey}`

export interface Cell {
  [key: CellName]: string
}
